import React, { useContext } from 'react';
import { SettingsContext } from "../../context/SettingsContext.js";
import { useIsNested } from "../../hooks/useIsNested.js";
import { useMobileCheck } from "../../hooks/useMobileCheck.js";
import { MenuProvider } from "../../provider/MenuProvider/MenuProvider.js";
import { SearchProvider } from "../../provider/SearchProvider/SearchProvider.js";
import { ContextMenuColumnItemsConnected } from "../ContextMenuColumnItems/ContextMenuColumnItems.js";
import { ContextMenuColumnList } from "../ContextMenuColumnList/ContextMenuColumnList.js";
import { ContextMenuColumnNode } from "../ContextMenuColumnNode/ContextMenuColumnNode.js";
import { ContextMenuColumnTarget } from "../ContextMenuColumnTarget/ContextMenuColumnTarget.js";
import { ContextMenuColumnTop } from "../FloatingColumnTop/ContextMenuColumnTop.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ContextMenuColumn({
  label,
  folderItem,
  items,
  children,
  searchString: externalSearchString,
  active,
  showSearchInput,
  customContent,
  level = 0,
  favorites = [] // set favorites only on root level
}) {
  const isNested = useIsNested();
  const isMobile = useMobileCheck();
  const {
    inlineSearch,
    externalSearch
  } = useContext(SettingsContext);
  return /*#__PURE__*/_jsx(SearchProvider, {
    externalSearchString: externalSearchString,
    items: items,
    children: /*#__PURE__*/_jsx(MenuProvider, {
      virtual: (inlineSearch || externalSearch) ?? false,
      level: level,
      children: /*#__PURE__*/_jsxs(ContextMenuColumnNode, {
        children: [/*#__PURE__*/_jsx(ContextMenuColumnTarget, {
          folderItem: folderItem,
          active: active,
          children: children
        }), /*#__PURE__*/_jsxs(ContextMenuColumnList, {
          setInitialFocus: ((!isNested || isMobile) && inlineSearch && !externalSearch) ?? false,
          level: level,
          children: [/*#__PURE__*/_jsx(ContextMenuColumnTop, {
            label: label,
            showSearchInput: showSearchInput,
            level: level
          }), customContent, /*#__PURE__*/_jsx(ContextMenuColumnItemsConnected, {
            level: level,
            favorites: favorites
          })]
        })]
      })
    })
  });
}